import { z } from "zod";
import { marketSchema } from "./market.js";
export const healthResponseSchema = z.object({
    status: z.literal("ok"),
    market: marketSchema,
});
